/**
 * @author xianminghong 2017-06-20
 */

// import { DTO } from 'src/dto/DTO'
import { Utils } from "./utils";
import { Message } from 'element-ui';
import { isEmptyArray, isNull } from "./validateBase";
/**
 * 后台返回
 * @backend ytd.framework.dto.RestResult
 */
class DownloadRestResultDTO {
    // /**
    //  * 错误码
    //  * @type {String}
    //  *errorCode = '0000'
    //     /**
    //      * 数据
    //      * @type {Object}
    //      * data = {}
    //     /**
    //      * 报错提示
    //      * @type {String}
    //      *errorMessage = ''
    // /**
    //  *
    //  * @param restResult
    //  * @param customConfig
    //  * @returns {RestResultDTO}
    //  */

    static showError(restResult, that) {
        return new Promise((resolve, reject) => {
            if (restResult.headers['content-type'].includes('json')) {
                // 此处拿到的data才是blob
                const { data } = restResult
                const reader = new FileReader()
                reader.onload = () => {
                    const { result } = reader
                    const errorInfos = JSON.parse(result)
                    const { msg } = errorInfos
                    Message.error(msg)
                    resolve(false)
                }
                reader.onerror = err => {
                    resolve(false)
                }
                reader.readAsText(data)
            } else {
                resolve(true)
            }
        })
    }

    static async from(restResult, customConfig) {
            const restResultDTO = new DownloadRestResultDTO()
            let { type } = customConfig
            let url = ''
            let name = ''
            if (restResult) {
                if (!isNull(type) && type == 'csv') {
                    const text = await restResult.data.text()
                    url = window.URL.createObjectURL(new Blob([`\ufeff${text}`], { type: 'text/csv;charset=UTF-8' }));
                    name = restResult.headers['filename'];

                } else {
                    url = window.URL.createObjectURL(new Blob([restResult.data]));
                }
                Utils.dowLoadFile(url, isNull(name) ? `${customConfig.name}.xlsx` : decodeURI(name));
                restResultDTO.data = restResult.data || false;
                restResultDTO.errorMessage = restResult.data ? '下载出错了' : '文件解析出错！'

            }
            return restResultDTO
        }
        /**下载zip
         *
         * @param restResult
         * @param customConfig
         * @returns {RestResultDTO}
         */
    static zip(response, customConfig) {
        let restResultDTO = new DownloadRestResultDTO()
        try {
            let enc = new TextDecoder('utf-8')
            let res = JSON.parse(enc.decode(new Uint8Array(response.data))) //转化成json对象
            restResultDTO = res;
        } catch (res) {
            const blob = new Blob([response.data], );
            // const filename = response.headers['content-disposition'];
            const filename = `${customConfig.name}.xlsx`;
            const downloadElement = document.createElement('a');
            const href = window.URL.createObjectURL(blob); //创建下载的链接
            console.log(href);
            downloadElement.href = href;
            [downloadElement.download] = [filename];
            // [downloadElement.download] = [customConfig.title];
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放blob对象
            restResultDTO.data = response.data || false
                // restResultDTO.errorCode = '0000'
            restResultDTO.errorMessage = response.data ? '下载出错了' : '文件解析出错！'
                // restResultDTO.errorMessage = '操作成功'
        }
        return restResultDTO
    }
}

export { DownloadRestResultDTO }